import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../../../components/ui/dialog";
import { useHistorico } from "../hooks/use-suporte";
import { Message } from "../types";
import { horaMensagem } from "./format";

interface HistoricoDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  contactId: string;
  titulo: string;
}

const REMETENTE: Record<Message["sender_type"], string> = {
  contact: "Entregador",
  bot: "Assistente",
  agent: "Atendente",
  system: "Sistema",
};

// Todas as mensagens do entregador (todos os atendimentos), agrupadas por
// atendimento, do mais recente para o mais antigo.
export function HistoricoDialog({ open, onOpenChange, contactId, titulo }: HistoricoDialogProps) {
  const { data, isLoading } = useHistorico(open ? contactId : null);

  const porTicket = new Map<string, Message[]>();
  for (const m of data?.items ?? []) {
    porTicket.set(m.ticket_id, [...(porTicket.get(m.ticket_id) ?? []), m]);
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[85vh] overflow-y-auto sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>Histórico do entregador</DialogTitle>
          <DialogDescription>{titulo}</DialogDescription>
        </DialogHeader>
        {isLoading && <p className="text-sm text-muted-foreground">Carregando…</p>}
        {Array.from(porTicket.entries()).map(([ticketId, msgs]) => (
          <section key={ticketId} className="space-y-1 border-t pt-3">
            <p className="text-xs font-semibold text-muted-foreground">
              Atendimento de {horaMensagem(msgs[msgs.length - 1].created_at)}
            </p>
            {[...msgs].reverse().map((m) => (
              <p key={m.msg_id} className="text-sm">
                <span className="font-medium">{m.sender_name ?? REMETENTE[m.sender_type]}:</span>{" "}
                <span className="whitespace-pre-wrap">{m.body}</span>
              </p>
            ))}
          </section>
        ))}
        {data?.next_cursor && (
          <p className="text-xs text-muted-foreground">Mostrando as 200 mensagens mais recentes.</p>
        )}
      </DialogContent>
    </Dialog>
  );
}
